import React from "react";
import Controls from "../form/controls/Controls";

const pageSizeOption = [
  {
    id: 5,
    name: "5",
  },
  {
    id: 10,
    name: "10",
  },
  {
    id: 20,
    name: "20",
  },
  {
    id: 50,
    name: "50",
  },
  {
    id: 100,
    name: "100",
  },
];

const PageSize = ({ limit, setLimit, setNumberPage }) => {
  const handlePageSize = (e) => {
    const { value } = e.target;
    setLimit(value);
    setNumberPage(1);
  };
  return (
    <Controls.Select
      name="pageSize"
      label="Page size"
      style={{ width: "80px", marginLeft: "10px" }}
      value={limit}
      onChange={handlePageSize}
      options={pageSizeOption}
    />
  );
};

export default PageSize;
